const Service = () => {
    return(
        <>
        <section class="inner-banner alternate">
            <div class="image-layer" style={{"background-image": `url(images/background/banner-bg-1.jpg)`}}></div>
            <div class="auto-container">
                <div class="inner">
                    <div class="title-box">
                        <h1>Services We Offer</h1>
                        <div class="d-text">Professional web, mobile, and digital services for every industry</div>
                    </div>
                </div>
            </div>
        </section>
        
         <section className="services-section">
            <div className="gradient-layer"></div>
            <div className="pattern-layer"></div>

            <div className="auto-container">
                <div className="row clearfix">

                    {/* Column 1 */}
                    <div className="column col-lg-4 col-md-12 col-sm-12">
                        <div className="sec-title wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                            <div className="upper-text">AlphaBlind Web & App Services</div>
                            <h2><strong>Our Core Services</strong></h2>
                            <div className="lower-text">Professional digital solutions for business growth</div>
                        </div>

                        {/* Web Design & Development */}
                        <div className="service-block wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/web1.png" style={{ width: "150px", height: "150px", objectFit: "contain" }}  alt="" /></div>
                                </div>
                                <h3>Web Design & Development</h3>
                                <div className="text">
                                    Modern, responsive, and high-performance websites tailored to your business goals.
                                </div>
                            </div>
                        </div>
                        

                        {/* Android App Development */}
                        <div className="service-block wow fadeInUp" data-wow-delay="600ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/android.png" alt="" /></div>
                                </div>
                                <h3>Android App Development</h3>
                                <div className="text">
                                    Scalable and feature-rich Android applications built for performance and reliability.
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="column col-lg-4 col-md-12 col-sm-12">

                        {/* iOS App Development */}
                        <div className="service-block wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/ios1.png" alt="" /></div>
                                </div>
                                <h3>iOS App Development</h3>
                                <div className="text">
                                    Robust, secure, and elegant iOS applications crafted for seamless user experience.
                                </div>
                            </div>
                        </div>

                        {/* SEO Services */}
                        <div className="service-block wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/seo.png" alt="" /></div>
                                </div>
                                <h3>SEO Optimization</h3>
                                <div className="text">
                                    Improve website visibility, rank higher on search engines, and attract quality traffic.
                                </div>
                            </div>
                        </div>

                        {/* UI/UX Design */}
                        <div className="service-block wow fadeInUp" data-wow-delay="600ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/uiux.png" alt="" /></div>
                                </div>
                                <h3>UI / UX Design</h3>
                                <div className="text">
                                    Clean, intuitive, and user-centric designs that enhance digital experiences.
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Column 3 */}
                    <div className="column col-lg-4 col-md-12 col-sm-12">

                        {/* E-Commerce Development */}
                        <div className="service-block wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/ecom1.png" alt="" /></div>
                                </div>
                                <h3>E-Commerce Development</h3>
                                <div className="text">
                                    Fast, scalable, and conversion-focused online stores that boost your sales.
                                </div>
                                {/* <div className="more-link">
                                    <Link to="/services/ecommerce"><span className="fa fa-arrow-right"></span></Link>
                                </div> */}
                            </div>
                        </div>

                        {/* Website Maintenance */}
                        <div className="service-block wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/main.png" alt="" /></div>
                                </div>
                                <h3>Website Maintenance</h3>
                                <div className="text">
                                    Keep your website updated, secure, fast, and running smoothly at all times.
                                </div>
                            </div>
                        </div>

                        {/* Digital Marketing */}
                        <div className="service-block wow fadeInUp" data-wow-delay="600ms" data-wow-duration="1500ms">
                            <div className="inner-box">
                                <div className="icon-outer">
                                    <span className="icon-bg"></span>
                                    <div className="icon-box"><img src="assets/images/images/1.png" alt="" /></div>
                                </div>
                                <h3>Digital Marketing</h3>
                                <div className="text">
                                    Grow your brand with targeted digital campaigns across multiple platforms.
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
        </>
    )
}

export default Service;